import "./skills.scss";
import HTML5 from "../../img/HTML5.png";
import CSS3 from "../../img/CSS3.png";
import JavaScript from "../../img/JavaScript.png";
import PHP from "../../img/PHP.png";
import React from "../../img/React.png";
import NodeJS from "../../img/NodeJS.png";
import Express from "../../img/Express.png";
import MongoDB from "../../img/MongoDB.png";
import SASS from "../../img/SASS.png";
import MySQL from "../../img/MySQL.png";
import CPP from "../../img/CPP.png";
import Java from "../../img/Java.png";

function skills() {
  return (
    <section className="main-container" id="skills">
      <hr />
      <div className="container">
        <h2 className="heading">
          <span className="heading-main">Skills</span>
          <span className="heading-sub">
            Explore my web development journey through a showcase of skills,
            revealing my commitment and expertise in crafting dynamic and
            innovative solutions in the digital realm.
          </span>
        </h2>
        <div className="skill-container">
          <div className="skill">
            <div className="skill-image">
              <img src={HTML5} />
              <h3>HTML5</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={CSS3} />
              <h3>CSS3</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={SASS} />
              <h3>SASS</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={JavaScript} />
              <h3>JavaScript</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={React} />
              <h3>React</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={NodeJS} />
              <h3>Node JS</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={Express} />
              <h3>Express</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={MongoDB} />
              <h3>MongoDB</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={PHP} />
              <h3>PHP</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={MySQL} />
              <h3>MySQL</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={Java} />
              <h3>Java</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
          <div className="skill">
            <div className="skill-image">
              <img src={CPP} />
              <h3>CPP</h3>
            </div>
            {/* <div className="skill-text">
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default skills;
